import React, {useEffect, useLayoutEffect, useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    Typography
} from "@material-tailwind/react";
import MapComponent from "../../shared/map_component";
import axios from "axios";
import RoadSelect from "../../shared/road_select";

const AddressCorrection = ({lot, movement}) => {
    const [lotNotes, setLotNotes] = useState("");
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [loaderActive, setLoaderActive] = useState(false);
    const [error, setError] = useState(null);
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [address, setAddress] = useState({
        road_id: "",
        road_name: "",
        ext_num: "",
        int_num: "",
        neighborhood_id: "",
        address_references: ""
    });

    useLayoutEffect(() => {
        setAddress({
            road_id: lot.road_id,
            road_name: lot.road_name,
            ext_num: lot.ext_num,
            int_num: lot.int_num,
            neighborhood_id: lot.neighborhood_id,
            address_references: lot.address_references,
        });
        setLotNotes(lot.notes);
    }, [lot]);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    useEffect(() => {
        async function fetchSelectsData() {
            try {
                const [neighborhoodsResponse] = await Promise.all([
                    fetch(`/neighborhoods.json`),
                ]);

                if (neighborhoodsResponse.ok) {
                    const neighborhoodsData = await neighborhoodsResponse.json();
                    setNeighborhoods(neighborhoodsData);
                } else {
                    console.log("No se encontraron colonias para este código.");
                }

            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        fetchSelectsData();
    }, []);

    const handleReset = () => {
        window.location.replace('movements');
    };

    const handleSubmit = async () => {
        try {
            setLoaderActive(true);
            const response = await axios.put(`lots/${lot.parcel_code}.json`, {
                lot: {
                    road_id: address.road_id,
                    neighborhood_id: address.neighborhood_id,
                    ext_num: address.ext_num,
                    int_num: address.int_num,
                    address_references: address.address_references,
                    notes: lotNotes,
                    reason_type_id: movement.id,
                },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });
            if (response.status === 200) {
                setOpenEndDialog(true);
                const url = `/lots/${lot.parcel_code}/print_movement.pdf`;
                window.open(url, '_blank');
                setLoaderActive(false);
            } else {
                setError('Error al actualizar dirección del predio. Verifica los datos.');
                setLoaderActive(false);
            }
        } catch (err) {
            setError('Error al guardar. Verifica los datos.');
            setLoaderActive(false);
        }
    };

    return (
        <>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información del predio
                </h6>
                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        {lot && (
                            <CardBody className='p-0'>
                                <div className="w-full mb-4 bg-gray-100">
                                    {(lot.latitude && lot.longitude) && (
                                        <MapComponent
                                            parcel_code={lot.parcel_code}
                                            latitude={lot.latitude}
                                            longitude={lot.longitude}
                                        />
                                    )}
                                </div>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    REGISTRO DEL PREDIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    R.P.P.
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Insc.
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.inscription}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Folio
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.folio}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Libro
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.book}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha efecto
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Bim
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_bimester}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Año
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_year}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha exento
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    PROPIETARIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                {lot.contributor_type === 'P' ? (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Nombre
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido paterno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.parental_last_name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido Materno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.maternal_last_name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Razón social
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className='flex flex-row gap-4 mt-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Dirección
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.contributor_street}
                                                            {lot.contributor_ext_num ? " #" + lot.contributor_ext_num : ""}
                                                            {lot.contributor_neighborhood ? ', ' + lot.contributor_neighborhood : ''}
                                                            {lot.contributor_postal_code ? ', C.P. ' + lot.contributor_postal_code : ''}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Teléfono
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.phone ? lot.phone : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            RFC
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.rfc ? lot.rfc : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex-auto py-10 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Dirección
                </h6>
                <Card className='w-full border border-blue-gray-100 rounded-b-lg rounded-t-none' shadow={false}>
                    <CardBody className='p-4'>
                        <div className='flex flex-row gap-4'>
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Calle
                                </label>
                                <RoadSelect
                                    value={
                                        address.road_id
                                            ? {
                                                label: address.road_name,
                                                value: address.road_id
                                            }
                                            : ''
                                    }
                                    onChange={(option) => {
                                        setAddress((prev) => ({
                                            ...prev,
                                            road_id: option.value,
                                            road_name: option.label,
                                        }));
                                    }}
                                />
                            </div>
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Ext. num.
                                </label>
                                <input
                                    type="text"
                                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    value={address.ext_num}
                                    onChange={(e) => setAddress({
                                        ...address,
                                        ext_num: e.target.value.toUpperCase()
                                    })}
                                />
                            </div>
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Int. Num.
                                </label>
                                <input
                                    type="text"
                                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    value={address.int_num}
                                    onChange={(e) => setAddress({
                                        ...address,
                                        int_num: e.target.value.toUpperCase()
                                    })}
                                />
                            </div>
                        </div>
                        <div className="flex flex-row gap-4">
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Colonia
                                </label>
                                <select
                                    value={address.neighborhood_id}
                                    onChange={(e) => setAddress({
                                        ...address,
                                        neighborhood_id: e.target.value.toUpperCase()
                                    })}
                                    className="w-full rounded-[7px] border-blue-gray-200"
                                >
                                    {neighborhoods.map((neighborhood) => (
                                        <option key={neighborhood.id}
                                                value={neighborhood.id}>
                                            {neighborhood.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-blue-gray-600 text-xs font-bold mb-2">
                                    Referencias
                                </label>
                                <input
                                    type="text"
                                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    value={address.address_references}
                                    onChange={(e) => setAddress({
                                        ...address,
                                        address_references: e.target.value.toUpperCase()
                                    })}
                                />
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-300 text-sm mt-3 mb-6 font-bold uppercase">
                            NOTAS DE MOVIMIENTOS DEL PREDIO
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                    >
                                        Notas
                                    </Typography>
                                    <textarea
                                        type="text"
                                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        value={lotNotes}
                                        onChange={(e) => setLotNotes(e.target.value)}
                                        rows="6"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <Button
                            className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                            onClick={() => handleSubmit()}
                            disabled={loaderActive}
                        >
                            GUARDAR
                        </Button>
                        {
                            error && <p style={{color: "red"}}>{error}</p>
                        }
                    </CardBody>
                </Card>
            </div>
            <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                <DialogHeader>Guardado</DialogHeader>
                <DialogBody>
                    <Typography>
                        Se actualizo el predio
                    </Typography>
                </DialogBody>
                <DialogFooter>
                    <Button
                        className="bg-green-500 text-white"
                        onClick={() => handleReset()}
                        disabled={loaderActive}
                    >
                        Finalizar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
};

export default AddressCorrection;
